//import moment from 'moment'

//let customDateFormatter = (value) => { return moment(value).format('DD/MM/YYYY') }

let searchInputs = [
    {
        id: 'reseller',
        label: 'Reseller',
        type: 'select',
        options: [
           
        ]
    },
    {
        id: 'underwriter',
        label: 'Underwriter',
        type: 'select',
        options: []
    },
    {
        id: 'claimReference',
        label: 'Claim Reference',
        type: 'text',
        placeholder: 'Claim Reference'
    },
    {
        id: 'relatedReference',
        label: 'Related Reference',
        type: 'text',
        placeholder: 'Related Reference'
    },
    {
        id: 'policyNumber',
        label: 'Policy Number',
        type: 'text',
        placeholder: 'Policy Number'
    },
    {
        id: 'claimantEmail',
        label: 'Claimant Email',
        type: 'text',
        placeholder: 'Claimant Email'
    },
    {
        id: 'incidentDate',
        label: 'Incident Date',
        type: 'text',
        placeholder: 'YYYY/MM/DD'
    },
    {
        id: 'incidentType',
        label: 'Incident Type',
        type: 'select',
        options: [
        ]
    },
    {
        id: 'fastTrackFilter',
        label: 'FastTrack Filter',
        type: 'select',
        options: [
            {
                id: 1,
                label: 'Only FastTracked'
            },
            {
                id: 2,
                label: 'Only non-FastTracked'
            }
        ]
    },
    {
        id: 'claimStatus',
        label: 'Claim Status',
        type: 'select',
        options: [
        ]
    },
    {
        id: 'personalCircumstances',
        label: 'Personal Circumstances',
        type: 'select',
        options: [
            {
                id: 0,
                label: 'NO'
            },
            {
                id: 1,
                label: 'YES'
            }
        ]
    },
]

let searchInputs2 = [
    {
        id: 'reseller',
        label: 'Reseller',
        type: 'select',
        options: [

        ]
    },
    {
        id: 'underwriter',
        label: 'Underwriter',
        type: 'select',
        options: []
    },
    {
        id: 'claimReference',
        label: 'Claim Reference',
        type: 'text',
        placeholder: 'Claim Reference'
    },
    {
        id: 'relatedReference',
        label: 'Related Reference',
        type: 'text',
        placeholder: 'Related Reference'
    },
    {
        id: 'policyNumber',
        label: 'Policy Number',
        type: 'text',
        placeholder: 'Policy Number'
    },
    {
        id: 'claimantEmail',
        label: 'Claimant Email',
        type: 'text',
        placeholder: 'Claimant Email'
    },
    {
        id: 'incidentDate',
        label: 'Incident Date',
        type: 'text',
        placeholder: 'YYYY/MM/DD'
    },
    {
        id: 'incidentType',
        label: 'Incident Type',
        type: 'select',
        options: [
        ]
    },
    {
        id: 'claimStatus',
        label: 'Claim Status',
        type: 'select',
        options: [
        ]
    }
]

let searchInputs3 = [
    {
        id: 'insuranceLine',
        label: 'Insurance Line',
        type: 'select',
        options: [

        ]
    },
    ...searchInputs
]


export { searchInputs, searchInputs2, searchInputs3 }